import IEngine from "../IEngine";
import IAudio from "../IAudio";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import MadnesAudio from "./MadnesAudio";
import IApp from "../IApp";
import ISymbols from "../pixi/ISymbols";
import EngineDebug from "../EngineDebug";

@injectable()
export default class MadnesEngine implements IEngine {

    audio: IAudio;
    debug: EngineDebug;

    constructor(
        @inject(SERVICE_IDENTIFIER.EngineAudio) audio: MadnesAudio,
        @inject(SERVICE_IDENTIFIER.EngineDebug) debug: EngineDebug
    ) {

        this.audio = audio;
        this.debug = debug;
    }

    app: IApp;
    symbols: ISymbols;
}